import { render, staticRenderFns } from "./SendDocumentDetail.vue?vue&type=template&id=558b814f&scoped=true&lang=pug"
import script from "./SendDocumentDetail.vue?vue&type=script&lang=ts"
export * from "./SendDocumentDetail.vue?vue&type=script&lang=ts"
import style0 from "./SendDocumentDetail.vue?vue&type=style&index=0&id=558b814f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558b814f",
  null
  
)

export default component.exports